import request from '@/request'

// 获取积分排行
export const getCreditDetailCount = data => {
  return request({
    url: '/mobile_UserAccountCredit/getCreditDetailCount.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取个人积分
export const getCreditAccountByTime = data => {
  return request({
    url: '/mobile_UserAccountCredit/getCreditAccountByTime.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 活动参与，阅读数，签到次数查询
export const selectCreditParty = data => {
  return request({
    url: '/mobile_UserAccountCredit/selectCreditParty.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 活动参与，阅读数，签到次数新增
export const addPartyCount = data => {
  return request({
    url: '/mobile_UserAccountCredit/addPartyCount.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 活动参与，阅读数，签到次数新增
export const addCreditParty = data => {
  return request({
    url: '/mobile_UserAccountCredit/addCreditParty.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 活动参与，阅读数，签到次数兑换
export const exchangeCreditParty = data => {
  return request({
    url: '/mobile_UserAccountCredit/exchangeCreditParty.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 提交地址信息
export const addAddress2 = data => {
  return request({
    url: '/mobile_PartyUser/add.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 根据openid关联抽奖结果
export const relation = data => {
  return request({
    url: '/mobile_LotteryBase/relation.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 活动详情
export const view = data => {
  return request({
    url: '/mobile_PartyInfo/view.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 1.19.1获得问卷
export const getExam = (data) => {
  return request({
    url: '/mobile_extExaminfo/getExam.action',
    method: 'post',
    data,
    secret: false
  })
}
// 1.19 .2 提交答题结果
export const save = (data) => {
  return request({
    url: '/mobile_extExaminfo/save.action',
    method: 'post',
    data,
    secret: false
  })
}
// 活动详情
export const getview = (data) => {
  return request({
    url: '/mobile_PartyInfo/view.action',
    method: 'post',
    data,
    secret: false
  })
}
// 获取活动参与次数
export const cutCreditPartyNum = (data) => {
  return request({
    url: '/mobile_UserAccountCredit/cutCreditPartyNum.action',
    method: 'post',
    data,
    secret: false
  })
}
// 扣除抽奖积分
export const cutCreditParty = (data) => {
  return request({
    url: '/mobile_UserAccountCredit/cutCreditParty.action',
    method: 'post',
    data,
    secret: false
  })
}
// 我的参与信息
export const getResult = (data) => {
  return request({
    url: '/mobile_MobPartyFew/getResult.action',
    method: 'post',
    data,
    secret: false
  })
}
export const getResultNum = (data) => {
  return request({
    url: '/mobile_MobPartyFew/getResultNum.action',
    method: 'post',
    data,
    secret: false
  })
}

export const getFewPartList = (data) => {
  return request({
    url: '/mobile_MobPartyFew/getFewPartList.action',
    method: 'post',
    data,
    secret: false
  })
}
// 获取闯关楼层
export const getstep = (data) => {
  return request({
    url: '/mobile_PartyDtcgInfo/getstep.action',
    method: 'post',
    data,
    secret: false
  })
}
// 获取闯关结果
export const addstep = (data) => {
  return request({
    url: '/mobile_PartyDtcgInfo/addstep.action',
    method: 'post',
    data,
    secret: false
  })
}
// 更新闯关抽奖
export const updateZj = (data) => {
  return request({
    url: '/mobile_PartyDtcgInfo/updateZj.action',
    method: 'post',
    data,
    secret: false
  })
}
// 校验当天是否抽奖
export const checkZj = (data) => {
  return request({
    url: '/mobile_PartyDtcgInfo/checkZj.action',
    method: 'post',
    data,
    secret: false
  })
}
// num 0 没抽奖 1已经抽奖
// 添加邮票

export const addStamps = (data) => {
  return request({
    url: '/exterior_intFtuCarnivalStamp_Vipwd/stampGet.action',
    method: 'post',
    data,
    isMd5: true
  })
}
